


























import {
  Component, mapState, Watch, mixins, EventBus,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import {
  CampaignStore, Payload, AuthorizationStore,
} from '@samclick-store-factory';
import { _isEmpty } from '@samclick-lodash';

class FormData {
    id: string | number = ''

    groupName: string = ''

    description: string = ''

    status: number = 1
}

class AddCampaignGroupState {
        showDialog: boolean = false

    formData = new FormData()

    action: string = 'add'

    tempEditRow = {};
}

    @Component({
      /**
         * Imported components
         * */
      components: {},
      /**
         * Stores values
         * */
      computed: {
        ...mapState({
          campaignStatus: (state: any) => state.commons.commonsStore.campaignStatus,
        }),
      },
      /**
         * Component properties
         * */
      props: {},
    })
export default class AddCampaignGroup extends mixins(SamclickMixins) {
        /**
         * Local state
         * */
        state = new AddCampaignGroupState();

        rules = {}

        /**
         * Watchers
         * */
        @Watch('state.showDialog')
        dialogWatcher(newVal: string, oldVal: string) {
          if (oldVal && !newVal) {
            this.state = new AddCampaignGroupState();
          }
        }

        @Watch('ifLocaleChange', { immediate: true })
        localeChanges() {
          this.rules = {
            groupName: [
              { required: true, message: this.$t('campaign.err_name'), trigger: 'blur' },
            ],
          };
        }

        /**
         * Methods
         * */
        toggleDialog(show: false, editRow: object = {}) {
          this.state.showDialog = show;

          if (!_isEmpty(editRow)) {
            const formData = new FormData();
            formData.id = editRow.id;
            formData.groupName = editRow.name;
            formData.description = editRow.description;
            formData.status = editRow.status;
            this.state.formData = formData;
            this.state.action = 'edit';
            this.state.tempEditRow = editRow;
          }
        }

        saveGroup() {
          this.$refs.campaignGroupForm.validate((valid) => {
            if (valid) {
              let promptMsg = this.$t('api_error.prompt_saving').toString();
              if (!_isEmpty(this.state.tempEditRow) && this.state.tempEditRow.status === 1 && this.state.formData.status === 2) {
                promptMsg = `${promptMsg} <br /><b>${this.$t('campaign.campaign_remove_noti')}</b> `;
              }
              this.showAlert(promptMsg, this.$data.SamclickAlert.WARNING, true).then(() => {
                const {
                  groupName, description, status, id,
                } = this.state.formData;
                CampaignStore.saveCampaignGroup(new Payload({
                  affiliateId: AuthorizationStore.currentLoggedUserInState.id,
                  name: groupName,
                  description,
                  status,
                  id,
                })).then((response) => {
                  this.showSuccessAlert();
                  this.toggleDialog(false);
                  this.emitEventHandler('reload');
                  EventBus.$emit('campaign-tab-search');
                }, (error) => {
                  if (error.status === 409) {
                    this.showAlert(this.$t('api_error.campaign_group_exist').toString(), this.$data.SamclickAlert.ERROR);
                  }
                });
              }).catch(() => {});
            }
          });
        }


        /**
         * Computed
         * */


        /**
         * Lifecycle hooks
         * */
        created() {
        }

        mounted() {
        }

        beforeUpdate() {
        }
}
